import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import BtnTable from '../../../components/buttons/BtnTable';
import HeaderSimple from '../../../components/headers/catalogs/HeaderSimple';
import MainLoader from '../../../components/Loaders/MainLoader';
import Error from '../../../components/errors/Error';
import UploadFileModal from '../../../components/modals/UploadFileModal';
//SLICE
import { uploadLevelExcelData } from '../../../store/slices/catalogs/uploadLevelData.slice';
import { resetState } from '../../../store/slices/catalogs/uploadLevelData.slice';
import { getCoursesThunk, deleteCourseThunk } from '../../../store/slices/catalogs/courses.slice';
import CardButtonProcess from '../../../components/cards/CardButtonProcess';
import { FaEdit, FaFileArchive } from 'react-icons/fa';
import { FaFileCircleCheck, FaFileCirclePlus } from 'react-icons/fa6';
import HeaderSimpleII from '../../../components/headers/catalogs/HeaderSimpleII';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import { getPoliticsThunk, deletePoliticThunk } from '../../../store/slices/catalogs/politics.slice';
import CardButtonEdit from '../../../components/cards/CardButtonEdit';

const PolicyList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, message, error } = useSelector(state => state.politics);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getPoliticsThunk());
    }, []);

    if (message === "Registro eliminado correctamente") {
        dispatch(getPoliticsThunk());
    }

    const handledelete = (id) => {
        dispatch(deletePoliticThunk(id));
    };

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={t("Politica de privacidad")} />
                    <div className="flex items-center justify-center h-[90%]">
                        {items.length > 0 ?
                            <CardButtonEdit
                                title={items[0].name}
                                background={'bg-slate-100'}
                            >
                                 <BtnTable action="edit" to={`/panel/privacy_policy/${items[0].id}`} />
                                 <BtnTable title={"¿Quieres eliminar la politica de privacidad?"} action="delete" onclick={() =>handledelete(items[0].id)} />
                            </CardButtonEdit> :
                            <CardButtonProcess title={'Crear nueva politica de privacidad'} background={'bg-slate-100'} to={`/panel/privacy_policy/policy_new`} >
                                <FaFileCirclePlus size={60} className='text-blue-600/80' />
                            </CardButtonProcess>
                        }


                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default PolicyList;